import React, { FC, useState } from 'react';
import { getUUID } from '../../../utils/UUID';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate } from 'react-router-dom';
import { IndicatorSaveRequestDto } from '../../../store/landscapeAPI/indicator/dto/request/indicator-save-request.dto';
import { saveIndicator } from '../../../store/landscapeAPI/indicator/reducers/indicator.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { ReportingDetailsIndicatorsAddTemplate } from '../../templates';
import { IndicatorResponseDto } from '../../../store/landscapeAPI/indicator/dto/response/indicator-response.dto';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface ReportingDetailsIndicatorsAddPageProps {}

const ReportingDetailsIndicatorsAddPage: FC<
  ReportingDetailsIndicatorsAddPageProps
> = () => {
  const [indicator, setIndicator] = useState<IndicatorResponseDto>({
    collections: [],
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    themes: [],
    versionId: 0,
    id: getUUID(),
    metricType: '',
    name: '',
    published: false,
    unit: '',
    compactId: '',
  });

  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();

  const handleOnChange = (indicator: IndicatorResponseDto) => {
    setIndicator(indicator);
  };

  const [selectedLanguage, setLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [fromLanguage, setFromLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [toLanguage, setToLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const generateAllTranslations: () => Promise<
    PromiseSettledResult<void>[]
  > = async () => {
    const rejectedResults: PromiseSettledResult<void>[] = [
      {
        status: 'rejected',
        reason: new Error(
          'Must save verification status before generating translation'
        ),
      },
    ];

    return Promise.reject(rejectedResults);
  };

  const generateTranslation = async () => {};

  const { status } = useSelector((state: RootState) => state.indicatorSlice);

  const handleAddIndicator = async (indicator: IndicatorResponseDto) => {
    const data: IndicatorSaveRequestDto = {
      compactId: getUUID(),
      goalId: getUUID(),
      id: indicator.id,
      metricType: indicator.metricType || '',
      name: indicator.name,
      published: indicator.published,
      unit: indicator.unit || '',
    };

    const response = await dispatch(
      saveIndicator({ saveRequest: data, language: selectedLanguage })
    );
    const newIndicator = response.payload as IndicatorResponseDto;

    navigate(`/reporting-details/indicators/${newIndicator.id}/edit`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <ReportingDetailsIndicatorsAddTemplate
      data={indicator}
      handleAddIndicator={handleAddIndicator}
      handleOnChange={handleOnChange}
      setLanguage={setLanguage}
      selectedLanguage={selectedLanguage}
      fromLanguage={fromLanguage}
      setFromLanguage={setFromLanguage}
      toLanguage={toLanguage}
      setToLanguage={setToLanguage}
      generateTranslation={generateTranslation}
      generateAllTranslations={generateAllTranslations}
    />
  );
};

export default ReportingDetailsIndicatorsAddPage;
